import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { TextAligning } from 'atoms/TextBox'
import {
  TextBoxHeadline3,
  TextBoxMaxLine1Footnote4,
} from 'atoms/TextBox/Templates'
import { TextBlock, TextBlockRowGap } from 'blocks/TextBlock'

export interface IPopupTitleWithCounter extends ITextBlockProps {
  counter: ITextBoxProps['title']
  title: ITextBoxProps['title']
}

export const PopupTitleWithCounter = ({
  counter,
  title,
  rowGap = TextBlockRowGap.INDENT_40,
  ...rest
}: IPopupTitleWithCounter) => {
  return (
    <TextBlock rowGap={rowGap} {...rest}>
      {counter && (
        <TextBoxMaxLine1Footnote4
          alignment={TextAligning.Left}
          title={counter}
        />
      )}
      <TextBoxHeadline3 title={title} />
    </TextBlock>
  )
}
